export function setCookie(name, value, days = 1, path = '/') {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

  const expires = "expires=" + date.toUTCString();
  const pathString = "path=" + path;

  document.cookie = name + "=" + value + "; " + expires + "; " + pathString;
}
